<!-- Small/Medium viewport -->
<div class="d-block d-lg-none">
  <div class="mb-4">
    <app-reviewandsendsummary [request]="request" [requestType]="requestType"></app-reviewandsendsummary>
  </div>
  <div class="mb-4">
    <app-reviewandsendactionslist [request]="request" (emailTemplate)="openEmailPreview($event)"></app-reviewandsendactionslist>
  </div>
  <div>
    <app-reviewandsenddocumentslist [request]="request" (openPDFViewer)="openPDFViewer.emit($event)"></app-reviewandsenddocumentslist>
  </div>
</div>

<!-- medium viewport -->
<div class="d-none d-lg-block">
  <app-reviewandsendsummary [request]="request" [requestType]="requestType" (emailTemplate)="openEmailPreview($event)"></app-reviewandsendsummary>
</div>
<div class="d-none d-lg-block container-fuid bg-white default-boxrounded">
  <div class="pt-4 p-1">
    <ul class="list-group">
      <li class="request-status-table-header list-group-item d-block pt-2">
        <nav aria-label="options"  ngbNav #nav="ngbNav" class="nav-tabs">
          <ng-container [ngbNavItem]="1">
              <a class="ms-4" ngbNavLink translate>Request.Status.Actions</a>
              <ng-template ngbNavContent>
                <div class="p-2">
                  <app-reviewandsendactionslist [request]="request" (emailTemplate)="openEmailPreview($event)"></app-reviewandsendactionslist>
                </div>
              </ng-template>
          </ng-container>
          <ng-container [ngbNavItem]="2">
              <a ngbNavLink translate>Request.Status.Documents</a>
              <ng-template ngbNavContent>
                  <div class="p-2">
                    <app-reviewandsenddocumentslist [request]="request" (openPDFViewer)="openPDFViewer.emit($event)"></app-reviewandsenddocumentslist>
                  </div>
              </ng-template>
          </ng-container>
          <div class="p-0">
              <hr class="hr" />
          </div>
        </nav>
      </li> 
      <li class="list-group-item d-block p-2 nohover subtable">
        <div [ngbNavOutlet]="nav"></div>
      </li>
    </ul>
  </div>
</div>
    